import { language } from '@tencent/ppd-base-libs';
/**
 * 语言映射
 */
export function getMapLang(): string {
  const LANG_MAP = {
    'zh-cn': 'cn',
    zh_cn: 'cn',
    'zh-hk': 'hk',
    zh_hk: 'hk',
    en: 'en',
  };
  return LANG_MAP[language.getLanguage()] || 'hk';
}

/** 值是否是对象 */
function isObject(value: any) {
  return Object.prototype.toString.call(value) === '[object Object]';
}

/** 批量根据语言环境处理对象/数组 */
export const getConfigWithLang = ({ configKey, originalObj }: { configKey: string[]; originalObj: object | any[] }) => {
  const lang = getMapLang();
  const resObj = {};
  if (Array.isArray(originalObj)) {
    return originalObj.map((item) => {
      if (Array.isArray(item) || isObject(item)) {
        return getConfigWithLang({ configKey, originalObj: item });
      }
      return item;
    });
  }
  for (const [key, value] of Object.entries(originalObj)) {
    if (configKey.includes(key) && isObject(originalObj[key])) {
      resObj[key] = originalObj[key][lang];
    } else if (Array.isArray(value)) {
      resObj[key] = getConfigWithLang({ configKey, originalObj: value });
    } else if (isObject(value)) {
      resObj[key] = getConfigWithLang({ configKey, originalObj: value });
    } else {
      resObj[key] = value;
    }
  }
  return resObj;
};

// 根据多语言获取JumpUrl
export function getJumpUrl(originalObj: any) {
  if (!originalObj) return;
  let url = '';
  const lang = getMapLang();
  if (lang === 'cn') {
    url = originalObj.jumpUrlCn;
  } else if (lang === 'en') {
    url = originalObj.jumpUrlEn;
  }
  return url || originalObj.jumpUrl;
}
